import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {}

const { onRequest, onSuccess, onFailure } = rootActions.companies.publishCompany
function* publishCompanySagaTask(payload) {
    try {
        const response = yield axios.put(`/companies/publish/${payload.id}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* publishCompanySaga(): any {
    yield takeLatest<TaskAction>(onRequest, publishCompanySagaTask)
}

export default publishCompanySaga
